import {
  ACTIVE_SESSION_LOADED
} from 'actions/activeSessionActions';
import { LOGOUT } from 'actions/authActions';

const initialState = '';

export default function auth (state = initialState, action) {
  switch (action.type) {
  case ACTIVE_SESSION_LOADED:
    return action.activeSession;
  case LOGOUT:
    return initialState;
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/activeSessionReducer.js